import React from "react";
import Header from "./Header";
import MenuPopup from "./MenuPopup";
import Article from "./Article";
import Footer from "./Footer";

function App() {
  return (
    <>
      <MenuPopup />
      <Header />
      <Article />
      <Footer />
    </>
  );
}

export default App;
